import s from './Skeleton.module.css';

export default function Skeleton({ width = '100%', height = 16, radius, style, ...rest }) {
  return (
    <span
      className={s.box}
      style={{ width, height, borderRadius: radius, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
}
